import Loader from '@pickleballinc/features/src/Loader/Loader';
import { notFound } from 'next/navigation';

import { useGetRSVPContent } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/matchdate/[matchDateId]/queries';
import RsvpsContent from '@/modules/league/new-components/rsvp-components/RsvpsContent';
import { GameDayInfo } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';

interface RsvpWrapperProps {
  headerContent: GameDayInfo;
  params: { slug: string; sessionId: string; matchDateId: string };
  user?: Session;
  isAuthorized: boolean;
}
const RsvpWrapper = ({ headerContent, params, user, isAuthorized }: RsvpWrapperProps) => {
  const { details } = headerContent;
  const { data, isLoading } = useGetRSVPContent(
    details.isWaitlist,
    params.matchDateId,
    details.clubId || '',
    isAuthorized,
    details.showPlayingDate,
    details.showWaitlistDate
  );

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <Loader backgroundColor='bg-leagues-300/90' />
      </div>
    );
  }

  if (!data) {
    return notFound();
  }

  const listOfNotPlayingPlayers = data?.players.notplayingList?.players || [];
  const isUserInLeague = user?.pbUuid
    ? listOfNotPlayingPlayers?.some(
        (player) => player.UserID_1 === user.pbUuid || player.UserID_2 === user.pbUuid
      )
    : false;

  const isClubMember = isUserInLeague && details?.clubId ? data?.clubMembers?.isClubMember : false;

  return (
    <RsvpsContent
      isAuthorized={isAuthorized}
      headerContent={headerContent}
      params={params}
      user={user}
      players={data?.players}
      isClubMember={isClubMember}
    />
  );
};

export default RsvpWrapper;
